module.exports = __webpack_public_path__ + "img/10.d22aaae5.png";